module.exports = __webpack_public_path__ + "static/media/318x180.d5ff1945.svg";